import _mapValues from "lodash/mapValues";
import _isPlainObject from "lodash/isPlainObject";
/* eslint-disable max-len */
// This proxy only works on dev environment.
const undefinedObjectPropertyErrorHandler = {
  get(target, key) {
    // `react-refresh` will try to access `object.$$typeof` to see if it's a React Element.
    if (key !== '$$typeof' && !Object.prototype.hasOwnProperty.call(target, key)) {
      console.warn(`[fe-i18n] Accessing unknown property '${key}' on translated object.`);
    }
    return target[key];
  }
};
export default function createNestedTranslate(i18nTranslateFn) {
  function translate(keyOrKeyMap, variables) {
    if (variables === 'lazy') {
      return lazyVariables => translate(keyOrKeyMap, lazyVariables);
    }
    if (Array.isArray(keyOrKeyMap)) {
      const [key, interpolateVariables] = keyOrKeyMap;
      return translate(key, interpolateVariables);
    }
    if (_isPlainObject(keyOrKeyMap)) {
      const result = _mapValues(keyOrKeyMap, value => translate(value));
      if (process.env.NODE_ENV === 'development') {
        // @ts-expect-error
        return new Proxy(result, undefinedObjectPropertyErrorHandler);
      }
      return result;
    }

    // @ts-expect-error
    return i18nTranslateFn(keyOrKeyMap, variables);
  }
  return translate;
}